import { render } from "./Index.vue?vue&type=template&id=7a0c5dc1&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=7a0c5dc1&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=7a0c5dc1&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0c5dc1"]])

export default __exports__